import 'regenerator-runtime/runtime';
import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Helmet } from 'react-helmet';
import { Provider, useQuery } from 'urql';

import { useSafeSetState } from '@quotient/riq-react-hooks';
import { ThemeProvider, Error, Loader } from '@quotient/riq-react-ui';
import { useUrqlClient } from '@quotient/riq-ql';
import { AppProvider } from '@quotient/riq-state';
import { ShoppingListProvider } from '@quotient/riq-shoppinglist';
import SiteMeta from 'couponscom-metaheaders/config/partners/demo/metaheaders.json';
import Routes from './Routes';
import { tokens, components } from './theme';

function renderMeta() {
  const meta: any = SiteMeta['metaheaders'];

  return (
    <Helmet>
      {meta && meta.favicon && (
        <link
          rel={meta.favicon[0].rel}
          type={meta.favicon[0].type}
          href={meta.favicon[0].url}
          sizes={meta.favicon[0].sizes}
        />
      )}
    </Helmet>
  );
}

function App() {
  const [appState, setAppState] = useSafeSetState({});
  const [urqlClient] = useUrqlClient();

  return (
    <Suspense fallback={() => <div>Loading...</div>}>
      <Provider value={urqlClient}>
        <AppProvider value={{ appState, setAppState }}>
          <ShoppingListProvider>
            {renderMeta()}
            <ThemeProvider tokens={tokens} components={components}>
              <ErrorBoundary FallbackComponent={() => <Error />}>
                <Suspense fallback={<Loader />}>
                  <Routes />
                </Suspense>
              </ErrorBoundary>
            </ThemeProvider>
          </ShoppingListProvider>
        </AppProvider>
      </Provider>
    </Suspense>
  );
}

export default App;
